var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticStyle:{"margin-left":"15px"}},[_vm._v(_vm._s(_vm.$t("Topo.delDeviceMessage")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }